var version = {
    "name":      "dativery",
    "buildDateCode": "20260630-140023",
    "buildDate": "Tue Jun 30 2026 14:00:23 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260630-140023",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;